import {Object3D} from "three";
import {FeatureBase} from "./feature.base";
import {Features} from "../decorators/features.decorator";
import {Comparable} from "./feature/comparable.feature";
import {debounceTime, Subject, takeUntil} from "rxjs";
import {dispose3dResource} from "../util/dispose-object";
import {Object3DEventMap} from "three/src/core/Object3D";

/**
 * Generic 3D Model which All products should extend
 */

@Features(Comparable)
export class Generic3DModel<T extends Object3D<any>> extends FeatureBase {

    protected _object: T;
    protected viewport: string = "";


    private debounceTime = 10; //[ms]
    public destroyed = new Subject<void>();
    protected _changed = new Subject<void>();
    public change = this._changed.pipe(
        takeUntil(this.destroyed),
        debounceTime(this.debounceTime)
    );

    constructor(name: string, object?: T) {
        super(name);
        this._object = object || new Object3D() as T;
        this.name = name;
        //this.data = {};
        //this.viewport = viewport;
    }

    public destroy(){
        dispose3dResource(this._object);
        this.destroyed.next();
    }

}